module.exports = __webpack_public_path__ + "img/symbol_10.51812c55.png";